module.exports = __webpack_public_path__ + "assets/sepa.6f1a445b.png";